import React from 'react';
import { useTranslation } from 'react-i18next';

export const SubTypeInfo = () => {
  const { t } = useTranslation();

  return (
    <>
      {t('epdWizard.wizardStep2.info.subType.description')}
      <br />
      <br />- {t('epdWizard.wizardStep2.info.subType.subType1')}
      <br />- {t('epdWizard.wizardStep2.info.subType.subType3')}
      <br />- {t('epdWizard.wizardStep2.info.subType.subType4')}
      <br />- {t('epdWizard.wizardStep2.info.subType.subType5')}
    </>
  );
};
